export const BRANDING = {
  appName: "Cajugram",
  appTitle: "Cajugram - Plataforma",
  appDescription: "Plataforma Cajugram",
  companyName: "Cajugram",
  logoAlt: "Logo Cajugram",
  themeColor: "#1F6B52",
} as const;

export type BrandingConfig = typeof BRANDING;
